export default __webpack_public_path__ + "images/d6c1d1bceab2c0370746731f6a70d9a5.png";